// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260409-0/static/css/" + chunkId + "." + {"2395":"53c8aa17","2425":"53c8aa17","2844":"53c8aa17","2865":"94d8fc8e","2918":"94d8fc8e","2982":"07a465cd","4312":"94d8fc8e","4767":"53c8aa17","7010":"94d8fc8e"}[chunkId] + ".chunk.css";
};